import { Component, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { CabeceraComponent } from './cabecera/cabecera.component';
import { DocsCtasComponent } from './docs-ctas/docs-ctas.component';
import { FormasPagoTabsComponent } from './formas-pago-tabs/formas-pago-tabs.component';
import { FormasPagoComponent } from './formas-pago/formas-pago.component';
import { ModalControlEfectivoComponent } from './modal-control-efectivo/modal-control-efectivo.component';

@Component({
  selector: 'app-pagos-cliente',
  templateUrl: './pagos-cliente.component.html',
  styleUrls: ['./pagos-cliente.component.scss'],
  providers: [SecurityService],
})
export class PagosClienteComponent implements OnInit {
  //Components
  @ViewChild(CabeceraComponent, { static: true }) cabeceraComponent: CabeceraComponent;
  @ViewChild(DocsCtasComponent, { static: true }) docsCtasComponent: DocsCtasComponent;
  @ViewChild(FormasPagoTabsComponent, { static: true }) formasPagoTabsComponent: FormasPagoTabsComponent;
  @ViewChild(FormasPagoComponent, { static: true }) formasPagoComponent: FormasPagoComponent;
  @ViewChild(ModalControlEfectivoComponent, { static: true }) modalControlEfectivoComponent: ModalControlEfectivoComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Almacena los hashes de los pagos ya enviados
  private sentPaymentsHashes: Set<string> = new Set();

  // Control de duplicidad para pagos
  private isSaving: boolean = false;
  private lastSaveTimestamp: number = 0;
  private readonly MIN_SAVE_INTERVAL: number = 5000; // 5 segundos
  private currentTransactionId: string = '';

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  data = {
    declaracionControl: null,
    saldoDocumento: null,
    difereciaPago: null,
    monto_coforme: null,
    forma_pago: null,
    diferencial_pago: null,
  };
  registrosGuardados: any = null;
  isProcessing: boolean = false;
  enableGuardarYPasar: boolean = false;
  enableCerrar: boolean = false;
  public recibirSaldo = 0;
  processing: boolean = false;
  cliente: any;

  someBooleanValue: boolean = false;

  // Utils
  private log: any;
  fechaPagoCheque: any = null;
  Declarante: number = 0;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private pagoService: PagoService
  ) {
    this.log = this.clog.log('REALIZAR-PAGOS');
  }

  /**
   * Cuando el diferencial a pagar queda en 0 y se está cubriendo con Pago a Cuenta,
   * no tiene sentido permitir agregar medios de pago (cheque/depósito/transferencia/efectivo).
   */
  get bloquearIngresoMediosPago(): boolean {
    const saldoDocumento: any[] = this.data && Array.isArray(this.data.saldoDocumento) ? this.data.saldoDocumento : [];
    const tieneDocs = saldoDocumento.length > 0;
    const montoConforme = Number(this.data && this.data.monto_coforme != null ? this.data.monto_coforme : 0);
    const diferencialCero = montoConforme === 0;
    const difs: any[] = this.data && Array.isArray(this.data.difereciaPago) ? this.data.difereciaPago : [];

    // `difereciaPago` aquí viene desde DocsCtasComponent y corresponde a pagos a cuenta/NC/excedentes seleccionados.
    // Si el diferencial quedó en 0 gracias a cualquiera de estos, se bloquea el ingreso de medios de pago.
    const tienePagoACuentaSeleccionado = difs.some((p: any) => {
      if (p == null || typeof p !== 'object') return false;
      const utilizado = parseFloat(p.pago_cuenta_utilizado) || 0;
      return utilizado > 0;
    });

    return tieneDocs && diferencialCero && tienePagoACuentaSeleccionado;
  }

  private permiteGuardarSinFormaPago(): boolean {
    return this.bloquearIngresoMediosPago;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
  }

  /**
   * Genera un ID único de transacción para prevenir duplicados
   */
  private generarIdTransaccion(): string {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 8);
    return `PAY_${timestamp}_${random}`;
  }

  onRealizarPago(declaracionControlData) {
    this.data.declaracionControl = declaracionControlData;
    const { cliente_proveedor_rut, vendedor_codigo, esTipoDeclaranteVendedor, clienteSeleccionado } = declaracionControlData;
    this.docsCtasComponent.loadData(vendedor_codigo, esTipoDeclaranteVendedor, cliente_proveedor_rut, clienteSeleccionado);
    this.cliente = clienteSeleccionado;
  }

  onLoadDetailsSuccess() {
    this.log('LoadDetailsSuccess');
    this.cabeceraComponent.disable();
  }

  onConformeAbono(doctosData) {
    // No va.
    // if (this.data.declaracionControl.esTipoDeclaranteVendedor)
    //   this.data.declaracionControl.cliente_proveedor_rut = doctosData.cliente_proveedor_rut
    delete doctosData.cliente_proveedor_rut;
    this.enableCerrar = doctosData.habilitarPago;
    delete doctosData.habilitarPago;
    this.data = { ...this.data, ...doctosData };
    this.formasPagoTabsComponent.loadData(doctosData, this.cliente);
    this.cabeceraComponent.disable();
  }

  onObtenerSaldoDocumentoError() {
    // this.cabeceraComponent.clearData()
    this.cabeceraComponent.enable();
  }

  onFormaPagoAgregada(data) {
    this.formasPagoComponent.loadData(data, this.data.monto_coforme);
    const { esTipoDeclaranteVendedor } = this.data.declaracionControl;
    this.enableGuardarYPasar = esTipoDeclaranteVendedor;
    // if (!this.enableCerrar)
    //   this.enableCerrar = !esTipoDeclaranteVendedor
    this.enableCerrar = true;
  }

  onfechaPagoCheque(fechaPago) {
    this.fechaPagoCheque = fechaPago;
    this.formasPagoTabsComponent.setFechaPago(this.fechaPagoCheque);
  }

  guardarYPasarAlSiguiente(callback: Function = null) {
    const { esTipoDeclaranteVendedor } = this.data.declaracionControl;

    const inputParams = this.validateAndCreatePayloadGuardarYPasar();

    this.log('payload', JSON.stringify(inputParams));

    //query
    this.pagoService.validaDeclaracion(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        // Resetear estado de procesamiento cuando hay errores de validación
        this.resetProcessingState();
        return;
      }

      this.log('respuesta', JSON.stringify(respuesta));
      this.registrosGuardados = respuesta;

      delete this.registrosGuardados.__typename;
      delete this.registrosGuardados.declaracionControl.__typename;
      delete this.registrosGuardados.pagos.__typename;
      this.registrosGuardados.pagos.map((pago) => {
        delete pago.__typename;
        if (pago.saldoDocumento) pago.saldoDocumento.map((saldo) => delete saldo.__typename);
        if (pago.difereciaPago) pago.difereciaPago.map((diferencia) => delete diferencia.__typename);
        if (pago.forma_pago) pago.forma_pago.map((formaPago) => delete formaPago.__typename);
      });

      this.toastrService.success('Registro realizado con éxito');

      // this.clearChilds()
      // if (esTipoDeclaranteVendedor)
      this.clearCurrentBody();

      // if (esTipoDeclaranteVendedor)
      //   this.enableCerrar = true
      this.enableGuardarYPasar = false;

      this.onRealizarPago(this.data.declaracionControl);

      if (callback) callback();
    });
  }

  validateAndCreatePayloadGuardarYPasar() {
    // Obtener data
    const { declaracionControl, monto_coforme, saldoDocumento, difereciaPago } = _.cloneDeep(this.data);
    const formaPagoData = this.formasPagoComponent.getPagosData(this.data);
    const pagos = this.registrosGuardados && this.registrosGuardados.pagos ? this.registrosGuardados.pagos : [];

    const forma_pago = formaPagoData && Array.isArray(formaPagoData.forma_pago) ? formaPagoData.forma_pago : [];

    if (forma_pago.length === 0 && !this.permiteGuardarSinFormaPago()) {
      this.toastrService.warning('Agregue una forma de pago');
      return;
    }

    // Limpiar
    delete declaracionControl.clienteSeleccionado;
    delete declaracionControl.esTipoDeclaranteVendedor;
    forma_pago.forEach((fp) => {
      delete fp.index;
      delete fp.checked;
    });

    // payload
    const inputParams = {
      addPago: {
        saldoDocumento, //: saldoDocumento.filter(p => p.selected),
        difereciaPago,
        forma_pago,
        monto_coforme,
      },
      entidad: {
        declaracionControl,
        pagos,
      },
    };

    return inputParams;
  }

  // clearChilds(cleanAll: boolean = false) {
  //   this.log('clearChilds', 'cleanAll', cleanAll, this.data.declaracionControl)
  //   if (!cleanAll && this.data && this.data.declaracionControl && !this.data.declaracionControl.esTipoDeclaranteVendedor) {
  //     this.log('caso 1')
  //     this.cabeceraComponent.clearData()
  //   } else {
  //     this.log('caso 2')
  //     this.cabeceraComponent.clearData()
  //   }

  //   this.docsCtasComponent.clearData()
  //   this.formasPagoTabsComponent.clearData()
  //   this.formasPagoComponent.clearData()
  // }

  clearHeader() {
    this.cabeceraComponent.clearData();
  }

  clearCurrentBody() {
    this.docsCtasComponent.clearData();
    this.formasPagoTabsComponent.clearData();
    this.formasPagoComponent.clearData();
  }

  openModalControlEfectivoComponent() {
    // Validaciones de duplicidad
    if (this.isProcessing || this.isSaving) {
      this.toastrService.warning('Ya se está procesando un pago. Espere a que termine.');
      return;
    }

    const now = Date.now();
    if (now - this.lastSaveTimestamp < this.MIN_SAVE_INTERVAL) {
      this.toastrService.warning(`Debe esperar ${Math.ceil((this.MIN_SAVE_INTERVAL - (now - this.lastSaveTimestamp)) / 1000)} segundos antes de realizar otro pago.`);
      return;
    }

    this.isProcessing = true;
    this.isSaving = true;
    this.lastSaveTimestamp = now;
    this.currentTransactionId = this.generarIdTransaccion();

    try {
      if (this.enableGuardarYPasar) {
        this.guardarYPasarAlSiguiente(this.openModalControlEfectivoComponentP2);
        return;
      }

      const { value } = this.cabeceraComponent.formHeader;
      if (value.declararPor == '_TIPO_DECLARANTE_CLIENTE_' || value.declararPor == '_TIPO_DECLARANTE_OTRO_') {
        this.log('Declarante', 'Cliente u OTRO');
        this.Declarante = 0;
        this.openModalControlEfectivoComponentP2();
      } else {
        this.log('Declarante', 'Vendedor');
        this.Declarante = 1;
        this.openModalControlEfectivoComponentP2();
      }
    } catch (error) {
      this.log('error', error);
      this.resetProcessingState();
    }
  }

  /**
   * Resetea el estado de procesamiento
   */
  private resetProcessingState() {
    this.isProcessing = false;
    this.isSaving = false;
    this.currentTransactionId = '';
  }

  // se hace una función de flecha ya que viene de una callback y preciso acceso al contexto de la CLASE (this.)
  openModalControlEfectivoComponentP2 = () => {
    const { esTipoDeclaranteVendedor } = this.data.declaracionControl;

    let inputParams = {};
    if (esTipoDeclaranteVendedor && this.registrosGuardados && this.registrosGuardados.pagos) {
      this.processing = true;
      this.log('payload Modal', 'caso 1');
      inputParams = this.validateAndCreatePayloadModalFromVendedor();
    } else {
      this.processing = true;
      inputParams = this.validateAndCreatePayloadModalFromCliente();
      this.log('payload Modal', 'caso 2');
    }

    // Si inputParams es null o undefined, no continuar
    if (!inputParams) {
      this.processing = false;
      this.resetProcessingState();
      return;
    }

    // Agregar transactionId para prevenir duplicados
    if (inputParams['entidad']) {
      inputParams['entidad']['transactionId'] = this.currentTransactionId;
    }

    this.log('payload Modal', JSON.stringify(inputParams));
    this.modalControlEfectivoComponent.loadData(inputParams, this.Declarante); //doctosCtasData.diferencial)
  };

  validateAndCreatePayloadModalFromVendedor() {
    const { declaracionControl } = _.cloneDeep(this.data);
    delete declaracionControl.esTipoDeclaranteVendedor;
    const pagos = this.registrosGuardados.pagos;

    this.log('declaracionControl', declaracionControl);
    this.log('pagos', pagos);

    const inputParams = {
      declaracionControl,
      pagos: pagos,
    };
    return inputParams;
  }

  validateAndCreatePayloadModalFromCliente() {
    const pagosData = this.formasPagoComponent.getPagosData(this.data);
    const forma_pago = pagosData && Array.isArray(pagosData.forma_pago) ? pagosData.forma_pago : [];
    this.data.forma_pago = forma_pago;
    this.data.diferencial_pago = pagosData === null ? 0 : pagosData.diferencial_pago;

    if (forma_pago.length === 0 && !this.permiteGuardarSinFormaPago()) {
      this.toastrService.warning('Agregue una forma de pago');
      // Resetear estado de procesamiento cuando hay error de validación
      this.resetProcessingState();
      this.processing = false;
      return;
    }

    forma_pago.forEach((fp) => {
      delete fp.index;
      delete fp.checked;
    });
    const inputParams = _.cloneDeep(this.data);
    delete inputParams.declaracionControl.esTipoDeclaranteVendedor;
    // return inputParams
    const { declaracionControl, saldoDocumento, difereciaPago, monto_coforme, diferencial_pago } = inputParams;
    return {
      declaracionControl,
      pagos: [
        {
          saldoDocumento,
          difereciaPago,
          monto_coforme,
          forma_pago: inputParams.forma_pago,
          diferencial_pago,
        },
      ],
    };
  }

  onControlEfectivoRealizado({ input, output }) {
    this.enableGuardarYPasar = false;
    this.enableCerrar = false;
    this.registrosGuardados = null;
    // this.clearChilds()
    this.clearHeader();
    this.clearCurrentBody();
    this.registrosGuardados = null;
    this.processing = false;

    // Resetear estado de duplicidad
    this.resetProcessingState();
  }

  onProcesingChance(isProcessing: boolean) {
    this.processing = isProcessing;
    // Si el procesamiento termina (con error o éxito), resetear también isProcessing e isSaving
    if (!isProcessing) {
      this.resetProcessingState();
    }
  }

  MontoxSaldo(resto) {
    console.log('************', resto);
    if (resto === 0) {
      this.recibirSaldo = 0;
      this.formasPagoTabsComponent.setLoadSaldo(0);
    } else {
      this.recibirSaldo = resto;
      this.formasPagoTabsComponent.setLoadSaldo(this.recibirSaldo);
    }
  }

  cancelar() {
    this.modalConfirm.show(() => {
      this.enableGuardarYPasar = false;
      this.enableCerrar = false;

      // Resetear estado de duplicidad
      this.resetProcessingState();

      // this.clearChilds(true)
      if (this.data && this.data.declaracionControl && this.data.declaracionControl.esTipoDeclaranteVendedor) {
        // Vendedor
        this.log('clean data vendedor');
        this.clearCurrentBody();
        this.onRealizarPago(this.data.declaracionControl);
      } else {
        // Cliente
        this.log('clean data cliente');
        this.clearHeader();
        this.clearCurrentBody();
        this.registrosGuardados = null;
      }
      // this.registrosGuardados = null // Borrar solo el actual
    });
  }
}
